import React from 'react';
import styles from './VictoryOverlay.module.css';

interface SeriesRecord {
  player1Wins: number;
  player2Wins: number;
  draws: number;
}

interface ActionButtonsProps {
  /** Callback to fight again (rematch) - stays with opponent */
  onFightAgain?: () => void;
  /** Callback to leave match and return to lobby */
  onLeaveMatch: () => void;
  /** Current series record between players */
  seriesRecord?: SeriesRecord;
  /** Current player ID for displaying "You" vs "Opponent" */
  currentPlayerId?: 'player1' | 'player2';
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onFightAgain,
  onLeaveMatch,
  seriesRecord,
  currentPlayerId = 'player1',
}) => {
  // Format series record for display
  const yourWins = currentPlayerId === 'player1'
    ? seriesRecord?.player1Wins ?? 0
    : seriesRecord?.player2Wins ?? 0;
  const opponentWins = currentPlayerId === 'player1'
    ? seriesRecord?.player2Wins ?? 0
    : seriesRecord?.player1Wins ?? 0;

  return (
    <div className={styles.actionButtons}>
      {/* Series record display */}
      {seriesRecord && (
        <div className={styles.seriesRecord}>
          <span className={styles.seriesLabel}>Series Score:</span>
          <span className={styles.seriesScore}>
            <span className={styles.yourScore}>You: {yourWins}</span>
            <span className={styles.scoreDivider}>-</span>
            <span className={styles.opponentScore}>Opponent: {opponentWins}</span>
            {seriesRecord.draws > 0 && (
              <span className={styles.draws}>(Draws: {seriesRecord.draws})</span>
            )}
          </span>
        </div>
      )}

      {/* Primary action: Fight Again */}
      {onFightAgain && (
        <button
          className={`${styles.button} ${styles.primary}`}
          onClick={onFightAgain}
          type="button"
        >
          Fight Again
        </button>
      )}

      {/* Secondary action: Leave Match */}
      <button
        className={`${styles.button} ${onFightAgain ? styles.secondary : styles.primary}`}
        onClick={onLeaveMatch}
        type="button"
      >
        Leave Match
      </button>
    </div>
  );
};

export default ActionButtons;
